import script from "./OnlineStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnlineStatus.vue?vue&type=script&setup=true&lang=ts"

import "./OnlineStatus.vue?vue&type=style&index=0&id=41f70ac0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f70ac0"]])

export default __exports__